<template>
  <div class="modal fade modal-andriod" id="pay-order" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div
      :class="[
    'modal-dialog',
    {'trier-update-dialog': show.paymentMethods && currentPackage.can_subscribe && this.userRole === 'trier' && currentPackage.is_update},
    {'support-subscribe-dialog': show.paymentMethods && currentPackage.can_subscribe},
    {'not-support-subscribe-dialog': show.paymentMethods && !currentPackage.can_subscribe},
    {'update-dialog': show.paymentMethods && currentPackage.is_update},
    {'wechatPay-dialog': show.wechatPay},
    {'airwallex-dialog': show.airwallexIframe}
    ]"
      role="document"
    >
      <div v-if="show.paymentMethods" class="modal-content" id="payment-methods">
        <modal-header></modal-header>
        <div class="modal-body">
          <h4 class="text-center">{{ $t('checkout') }}</h4>
          <p class="little-title">{{ $t('purchasePackage') }}</p>

          <p :class="{'valid-trier': validTrier}">
            <template v-if="trierUpdate || othersUserUpdate">
              <span class="upgrade-name pc-show">
                {{ $t('upgrade') }} {{ user.value_of_expire_in }} {{ $tc(user.unit_of_expire_in, user.value_of_expire_in) }} - {{ $t('type.' + currentPackage.type) }} - {{ currentPackage.device_count }} {{ $tc('devices', topupOrder.order_detail.device_count) }}
                <br />
                {{ $t('priceDifference') }}
              </span>
              <span class="upgrade-name phone-show">
                {{ $t('upgrade') }} {{ user.value_of_expire_in }} {{ $tc(user.unit_of_expire_in, user.value_of_expire_in) }}
                <br />
                {{ $t('type.' + currentPackage.type) }} - {{ currentPackage.device_count }} {{ $tc('devices', topupOrder.order_detail.device_count) }}
                <br />
                {{ $t('priceDifference') }}
              </span>
              <span class="pull-right">{{ $t(currentPackage.currency_code) }} {{ subTotal }}</span>
            </template>
            <template v-else>
              <span>{{ currentPackage.device_count }} {{ $tc('devices', topupOrder.order_detail.device_count) }} {{ currentPackage.name }}</span>
              <span class="pull-right">{{ $t(currentPackage.currency_code) }} {{ currentPackage.price }}</span>
            </template>
          </p>
        </div>
        <div class="modal-footer">
          <p class="p-t-b-15" :class="['choose-methods', {'stripe': show.stripePay}]" v-show="!show.loading">{{ $t('chooseMethods') }}</p>
          <spinner :show="show.loading && !loadPaymentMethodsFail" v-if="show.loading"></spinner>
          <div v-if="loadPaymentMethodsFail" :class="['load-fail-btn', isIE11 ? 'ie-style': '']" @click="getPaymentMethods">
            <button>{{$t('loadFail')}}</button>
          </div>
          <p class="methods-icon-list" v-show="!show.loading">
            <a
              href="javascript:void(0)"
              @click="choosePaymentMethod(item)"
              :class="['methods text-center', {'current-method': item.id === currentPaymentMethod.id && item.channel_id === currentPaymentMethod.channel_id}]"
              v-for="(item, index) in paymentMethods"
              :key="index"
              :title="item.channel_name || item.name"
            >
              <img :src="item.icon" :alt="item.channel_name || item.name" />
            </a>
          </p>
          <div id="stripe-container" v-if="show.stripePay">
            <h5>{{$t('cardDetails')}}</h5>
            <stripe :hanlderNameError="($event) => cardName = $event" :isSubscribe="isSubscribe"></stripe>
          </div>
          <p :class="['choose-subscribe', {'not-support-subscribe': !supportSubscribe}]" v-if="showSubscribeOption">
            <span>
              <span class="check-box" @click="changeSubscribeStatus">
                <img v-if="isSubscribe" src="/static/img/dashboard/agree_2x.png" />
                <span v-if="!isSubscribe" class="circle-span"></span>
              </span>
              <span class="subscribe-desc">{{ subscribeDescribe() }}</span>
            </span>
          </p>
          <p class="trier-subscribe-notice text-center">
            <span v-show="validTrierSubscribe">{{ $t('trierSubscribeNotice') }}</span>
          </p>
          <p>
            <router-link
              @click.native="webAlipay()"
              :to="'/dashboard?lang='+currentLang"
              target="_blank"
              :class="['form-submit', disabled ? 'disabled' : '']"
              :disabled="disabled"
              v-if="currentPaymentMethod.id == 'alipay_global'"
            >{{ $t('payNow') }}</router-link>
            <router-link
              @click.native="mugglepay()"
              :to="'/dashboard?lang='+currentLang"
              target="_blank"
              :class="['form-submit', disabled ? 'disabled' : '']"
              :disabled="disabled"
              v-else-if="currentPaymentMethod.id == 'mugglepay'"
            >{{ $t('payNow') }}</router-link>
            <router-link
              @click.native="paypalPay()"
              :to="'/dashboard?lang='+currentLang"
              target="_blank"
              :class="['form-submit', disabled ? 'disabled' : '']"
              :disabled="disabled"
              v-else-if="currentPaymentMethod.id == 'paypal'"
            >{{ $t('payNow') }}</router-link>
            <router-link
              @click.native="paymentwallPay()"
              :to="'/dashboard?lang='+currentLang"
              target="_blank"
              :class="['form-submit', disabled ? 'disabled' : '']"
              :disabled="disabled"
              v-else-if="currentPaymentMethod.id == 'paymentwall'"
            >{{ $t('payNow') }}</router-link>
            <router-link
              @click.native="paymentwallPay()"
              :to="'/dashboard?lang='+currentLang"
              target="_blank"
              :class="['form-submit', disabled ? 'disabled' : '']"
              :disabled="disabled"
              v-else-if="currentPaymentMethod.id == 'airwallex' && isMacSafari"
            >{{ $t('payNow') }}</router-link>
            <button
              @click="airwallex()"
              :class="['form-submit', disabled ? 'disabled' : '']"
              :disabled="disabled"
              v-else-if="currentPaymentMethod.id == 'airwallex' && !isMacSafari"
            >{{ $t('payNow') }}</button>
            <button @click="topup" class="form-submit" v-else :disabled="disabled">{{ $t('payNow') }}</button>
          </p>
          <div class="purchase-tips text-center">*{{$t('purchase_tips')}}</div>
        </div>
      </div>

      <div v-if="show.wechatPay" class="modal-content" id="wechat-qrcode">
        <modal-header></modal-header>
        <spinner class="spinner" :show="show.loading"></spinner>
        <div class="modal-body text-center" v-if="!show.loading">
          <div class="qr-code">
            <qr-code :text="qrText" :size="240"></qr-code>
          </div>
          <p class="scan-description">{{ $t('wechatPay') }}</p>
        </div>
        <div class="modal-footer" v-if="!show.loading">
          <p class="price">
            {{ $t('paymentAmount') }}
            <span>{{ $t(currentSymbol) }}{{ subTotal }}</span>
          </p>
        </div>
      </div>

      <div v-if="show.airwallexIframe" class="modal-content" id="airwallex-iframe">
        <svg class="icon close" @click="airwallexClose()"><use xlink:href="#icon-close"></use></svg>
        <div class="loading-box" v-show="show.loading">
          <spinner class="spinner" :show="show.loading"></spinner>
          <p>{{ $t('redirect') }}{{ $t('airwallex') }}{{ $t('wait') }}</p>
        </div>
        <iframe v-show="!show.loading" id="iframe" :src="airwallexIframe_url" frameborder="0" scrolling="no" width="100%" height="100%"></iframe>
        <button v-show="!show.loading" class="payCompleted" @click="airwallexClose()">{{ $t('payCompleted') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import QrCode from '../QrCode.vue';
import Spinner from '../Spinner.vue';
import Stripe from '../stripe/Stripe.vue';
import ModalHeader from '../modalHeader/ModalHeader.vue';
import { getGaData, addProduct, setAction } from '../../assets/js/ecommerceAnalytics';
import locales from './lang';
import { mapState } from 'vuex';
import { isMobile, isAndroid, isIOS, isMac, isWindows } from '../../lib/fun';
import cookie from '../../lib/cookie';

const UaRechargeActions = {
  CLICK_TO_START: 'Click to start',
  CHOOSE_PAYMENT_METHOD: 'Choose payment method',
  CLICK_TO_PAY_ORDER: 'Click to pay order',
  WECHAT_QRCODE_LOADED: 'Wechat QrCode loaded',
  CANCEL_PAYMENT: 'Cancel payment'
};
let timer;

export default {
  name: 'pay-order',
  components: { QrCode, Spinner, Stripe, ModalHeader },
  data: function () {
    return {
      isSubscribe: false,
      qrText: 'PlexVPN',
      topupOrder: {
        order_id: '',
        package_id: '',
        payment_logo: '',
        payment_method_id: '',
        status: '',
        order_detail: {
          available_days: 0,
          currency_symbol: '¥',
          device_count: 0,
          plan_fee: 0,
          plan_name: 0,
          total_amount: 0,
          upgrade_fee: 0
        }
      },
      show: {
        paymentMethods: false,
        confirmOrder: false,
        loading: false,
        wechatPay: false,
        stripePay: false,
        useExistStripePay: false,
        airwallexIframe: false
      },
      time: 3600,
      notFindOrder: this.$t('notFindOrder'),
      cardName: '',
      disabled: false,
      loadPaymentMethodsFail: false,
      isIE11: false,
      airwallexIframe_url: '',
      isMacSafari: false
    };
  },
  locales,
  computed: {
    language() {
      return this.$store.state.currentLang;
    },
    showSubscribeOption() {
      if (this.userRole === 'trier') {
        return this.currentPackage.can_subscribe;
      }
      return !this.currentPackage.is_update && this.currentPackage.can_subscribe;
    },
    supportSubscribe() {
      let paymentwallNotSupportSubscribe =
        this.currentPaymentMethod.id === 'paymentwall' &&
        ((this.currentPackage.frequency === 'year' && this.currentPackage.frequency_interval >= 1) ||
          (this.currentPackage.frequency === 'month' && this.currentPackage.frequency_interval >= 12) ||
          (this.currentPackage.frequency === 'week' && this.currentPackage.frequency_interval >= 52) ||
          (this.currentPackage.frequency === 'day' && this.currentPackage.frequency_interval >= 365));
      if (this.currentPaymentMethod.can_subscription === 0 || paymentwallNotSupportSubscribe) {
        return false;
      }
      return true;
    },
    validTrierSubscribe() {
      return this.isSubscribe && this.userRole === 'trier' && !!this.user.value_of_expire_in;
    },
    validTrier() {
      return this.userRole === 'trier' && !!this.user.value_of_expire_in;
    },
    trierUpdate() {
      return this.currentPackage.is_update && this.validTrier && !this.isSubscribe;
    },
    othersUserUpdate() {
      return this.currentPackage.is_update && !this.validTrier;
    },
    subTotal() {
      if (this.trierUpdate || this.othersUserUpdate) {
        return this.currentPackage.price_for_upgrade;
      }
      return this.currentPackage.price;
    },
    ...mapState({
      currentLang: state => state.currentLang,
      user: state => state.user,
      userRole: state => state.user['role'],
      tokenExpired: state => state.tokenExpired,
      currentPackage: state => state.currentPackage,
      currentSymbol: state => state.currentSymbol,
      currentPaymentMethod: state => state.paymentMethods.currentPaymentMethod,
      paymentMethods: state => state.paymentMethods.paymentMethods,
      stripe: state => state.stripe,
      card: state => state.card,
      cardError: state => state.cardError,
      cardNumberEmpty: state => state.cardNumberEmpty,
      nameError1: state => state.nameError1
    })
  },
  watch: {
    tokenExpired() {
      if (this.tokenExpired) {
        $('#pay-order').modal('hide');
      }
    },
    currentPackage() {
      if (!this.currentPackage.can_subscribe) {
        this.setSubscribeStatus(false);
      } else if (this.supportSubscribe) {
        if (this.currentPackage.given_days > 0) {
          this.setSubscribeStatus(true);
        } else {
          this.setSubscribeStatus(true);
        }
      } else {
        this.setSubscribeStatus(false);
      }
    },
    currentPaymentMethod() {
      if (this.showSubscribeOption && this.supportSubscribe) {
        this.isSubscribe = true;
      } else {
        this.isSubscribe = false;
      }
    },
    loadPaymentMethodsFail() {
      if (!this.loadPaymentMethodsFail) {
        this.initPaymentStatus();
      }
    },
    'show.airwallexIframe'(value) {
      if (!value) {
        this.airwallexClose()
      }
    }
  },
  created() {
    this.show.paymentMethods = true;
    this.loadPaymentMethods();
  },
  mounted() {
    let vmPay = this;
    vmPay.isIE11 = navigator.userAgent.indexOf('Trident') > -1;
    vmPay.isMacSafari = (navigator.userAgent.includes('Mac') && navigator.userAgent.includes('Safari')) || navigator.userAgent.includes('iPhone') || navigator.userAgent.includes('iPad');
    vmPay.loadV3Stripe();
    $('#pay-order').on('hidden.bs.modal', function () {
      for (let i in vmPay.show) {
        vmPay.show[i] = false;
      }
      vmPay.show.paymentMethods = true;
      clearInterval(timer);
      vmPay.time = 3600;
    });
    $('#pay-order').on('show.bs.modal', function () {
      // Show submit button
      $('button.form-submit').show();
      $('.trier-subscribe-notice').css({ marginTop: '0.2rem' });

      // Handling of payment method request failures
      if (vmPay.loadPaymentMethodsFail) {
        vmPay.show.loading = true;
        vmPay.getPaymentMethods();
        return;
      }

      vmPay.initPaymentStatus();

      window.localStorage.removeItem('currentPackage');
      window.localStorage.removeItem('orderNumber');
      window.localStorage.removeItem('isQueryPayStatus');
      window.localStorage.removeItem('currentPackageId');
      window.localStorage.removeItem('orderTracked');
      window.localStorage.removeItem('subscriptionId');
    });
  
    window.addEventListener("message", function (e) {
      console.log(e.data)
      let returnData = e.data
      if (returnData.cmd === 'airwallexClose') {
        vmPay.airwallexClose()
      }
    });
  },
  methods: {
    airwallexClose() {
      this.show.airwallexIframe = false
      $('#pay-order').modal('hide')
      $('#created-order').modal('show')
    },
    subscribeDescribe() {
      let frequencyInterval = this.currentPackage.frequency_interval;
      let frequency = this.currentPackage.frequency;
      if (this.language === 'zh') {
        let frequencyZh = '';
        if (frequency === 'year') {
          frequencyZh = '年';
        } else if (frequency === 'month') {
          frequencyZh = '月';
        } else if (frequency === 'week') {
          frequencyZh = '周';
        } else if (frequency === 'day') {
          frequencyZh = '天';
        }
        let nameZh = frequencyInterval > 1 ? frequencyInterval + frequencyZh : frequencyZh;
        return '订阅套餐，每' + nameZh + this.subTotal + '元，可随时前往支付平台取消';
      } else {
        let nameUs = frequencyInterval > 1 ? frequencyInterval + ' ' + frequency + 's' : frequency;
        return 'Billed $' + this.subTotal + ' every ' + nameUs + ', you can visit payment platform to cancel it at anytime';
      }
    },
    setSubscribeStatus(status) {
      this.isSubscribe = status;
    },
    changeSubscribeStatus() {
      if (this.supportSubscribe) {
        this.isSubscribe = !this.isSubscribe;
      }
    },
    choosePaymentMethod(item) {
      this.$store.commit('setCurrentPaymentMethod', item);
      if (this.currentPaymentMethod.id === 'stripe') {
        this.show.stripePay = true;
      } else {
        this.show.stripePay = false;
      }
      if (this.showSubscribeOption && this.supportSubscribe) {
        this.isSubscribe = true;
      } else {
        this.isSubscribe = false;
      }
    },
    loadPaymentMethods() {
      this.trackRecharge(UaRechargeActions.CLICK_TO_START);
      this.show.loading = true;
      this.getPaymentMethods();
    },
    gtmEvent(eventName, pageCategory, transactionId, transactionTotal, transactionCurrency, name, price, deviceCount) {
      // get eventName
      if (isMobile()) {
        if (isAndroid()) {
          eventName = 'Android_H5_' + eventName;
        } else if (isIOS()) {
          eventName = 'iOS_H5_' + eventName;
        } else {
          eventName = 'other_H5_' + eventName;
        }
      } else {
        if (isMac()) {
          eventName = 'Mac_PC_' + eventName;
        } else if (isWindows()) {
          eventName = 'Windows_PC_' + eventName;
        } else {
          eventName = 'other_PC_' + eventName;
        }
      }

      // Event snippet for payment page
      window.dataLayer &&
        window.dataLayer.push({
          event: eventName,
          pageCategory: pageCategory,
          transactionId: transactionId,
          transactionTotal: transactionTotal,
          transactionCurrency: transactionCurrency,
          transactionProducts: [
            {
              name: name,
              price: price,
              deviceCount: deviceCount
            }
          ]
        });
    },
    topup() {
      this.disabled = true;
      this.$store.commit('setNameError1', false);
      addProduct(getGaData(this.currentPackage, this.subTotal));
      setAction('checkout', { step: 2, list: 'PlexVPN', option: this.currentPaymentMethod.id });
      switch (this.currentPaymentMethod.id) {
        case 'wechatpay': {
          this.show.paymentMethods = false;
          this.show.loading = true;
          // Event snippet for pay_now_wechat page
          const eventValue = [
            'pay_now_wechat',
            'pay_now',
            this.topupOrder.order_id,
            this.topupOrder.order_detail.total_amount,
            this.topupOrder.order_detail.currency_symbol,
            this.currentPackage.name,
            this.currentPackage.price,
            this.currentPackage.device_count
          ];
          this.gtmEvent(...eventValue);
          this.show.wechatPay = true;
          this.wechatPay();
          break;
        }
        case 'stripe': {
          this.getStripeTokenId();
          break;
        }
      }
    },

    getStripeTokenId() {
      window.dataLayer && window.dataLayer.push({ event: 'pay_credit_card' });

      if (!this.cardName) {
        this.$store.commit('setNameError1', true);
        this.disabled = false;
        return;
      }
      if (this.cardNumberEmpty) {
        this.$store.commit('setCardError', this.$t('cardError'));
        this.disabled = false;
        return;
      }
      if (this.cardError) {
        this.disabled = false;
        return;
      }
      if (!this.card) {
        this.$store.commit('setCardError', this.$t('cardError'));
        this.disabled = false;
        return;
      }

      let striptVm = this;
      striptVm.stripe.createToken(striptVm.card, { name: striptVm.cardName }).then(function (result) {
        if (result.error) {
          striptVm.$store.commit('setCardError', result.error.message);
          striptVm.disabled = false;
        } else {
          striptVm.show.loading = true;
          $('button.form-submit').hide();
          $('.trier-subscribe-notice').css({ marginTop: '0.4rem' });
          // if reCAPTCHA3 Loading normally && stripe PaymentMethod，reCAPTCHA3 verification request， else normal payment request
          striptVm.validateGrecaptcha() && striptVm.currentPaymentMethod.id === 'stripe'
            ? striptVm.verification(event, result.token.id, striptVm.onSubmit)
            : striptVm.onSubmit(result.token.id);
        }
      });
    },
    onSubmit(stripeToken, recaptchaToken) {
      // stripeToken：stripe credit card token
      // recaptchaToken：reCAPTCHA3 verification token
      if (this.isSubscribe) {
        // Event snippet for pay_now_subscribe_stripe page
        const eventValue = [
          'pay_now_subscribe_stripe',
          'pay_now',
          this.topupOrder.order_id,
          this.topupOrder.order_detail.total_amount,
          this.topupOrder.order_detail.currency_symbol,
          this.currentPackage.name,
          this.currentPackage.price,
          this.currentPackage.device_count
        ];
        this.gtmEvent(...eventValue);
        this.stripeSubscribe(stripeToken, recaptchaToken);
      } else {
        // Event snippet for pay_now_stripe page
        const eventValue = [
          'pay_now_stripe',
          'pay_now',
          this.topupOrder.order_id,
          this.topupOrder.order_detail.total_amount,
          this.topupOrder.order_detail.currency_symbol,
          this.currentPackage.name,
          this.currentPackage.price,
          this.currentPackage.device_count
        ];
        this.gtmEvent(...eventValue);
        this.createOrderByStripe(stripeToken, recaptchaToken);
      }
    },

    wechatPay() {
      this.$http
        .post('api/topup?web=1&version=v2', {
          package_id: this.currentPackage.id,
          payment_method_id: this.currentPaymentMethod.id,
          promotion_source: cookie.getCookie('promotion_source') || ''
        })
        .then(response => {
          if (response.body.code === 0 && this.show.wechatPay) {
            window.localStorage.setItem('isQueryPayStatus', true);
            window.localStorage.setItem('currentPackageId', this.currentPackage.id);

            this.topupOrder = response.body.data;
            this.qrText = response.body.data.payment_extras.code_url;
            this.show.loading = false;
            this.trackRecharge(UaRechargeActions.WECHAT_QRCODE_LOADED);
            timer = setInterval(() => {
              if (this.time <= 0) {
                $('#pay-order').modal('hide');
                this.$store.commit('setOrderNumber', this.topupOrder.order_id);
                this.$store.commit('setQueryPayStatus', true);
              } else {
                this.$http.get('api/topup-order/' + this.topupOrder.order_id).then(result => {
                  if (result.body.code === 0 && result.body.data.state === 'paid') {
                    $('#pay-order').modal('hide');
                    this.$store.commit('setOrderNumber', this.topupOrder.order_id);
                    this.$store.commit('setQueryPayStatus', true);
                  }
                });
                this.time -= 3;
              }
            }, 3000);
          }
        });
    },

    webAlipay() {
      // Event snippet for pay_now_alipay page
      const eventValue = [
        'pay_now_alipay',
        'pay_now',
        this.topupOrder.order_id,
        this.topupOrder.order_detail.total_amount,
        this.topupOrder.order_detail.currency_symbol,
        this.currentPackage.name,
        this.currentPackage.price,
        this.currentPackage.device_count
      ];
      this.gtmEvent(...eventValue);
      addProduct(getGaData(this.currentPackage, this.subTotal));
      setAction('checkout', { step: 2, list: 'PlexVPN', option: this.currentPaymentMethod.id });
      window.localStorage.setItem('currentPaymentMethod', JSON.stringify(this.currentPaymentMethod));
      window.localStorage.setItem('currentPackage', JSON.stringify(this.currentPackage));
      window.localStorage.setItem('paymentLang', this.currentLang);
      this.$store.commit('setCurrentPayment', this.currentPaymentMethod.id);
      $('#pay-order').modal('hide');
      $('#creating-order').modal('show');
    },

    mugglepay() {
      // Event snippet for pay_now_mugglepay page
      const eventValue = [
        'pay_now_mugglepay',
        'pay_now',
        this.topupOrder.order_id,
        this.topupOrder.order_detail.total_amount,
        this.topupOrder.order_detail.currency_symbol,
        this.currentPackage.name,
        this.currentPackage.price,
        this.currentPackage.device_count
      ];
      this.gtmEvent(...eventValue);
      addProduct(getGaData(this.currentPackage, this.subTotal));
      setAction('checkout', { step: 2, list: 'PlexVPN', option: this.currentPaymentMethod.channel_id });
      window.localStorage.setItem('currentPaymentMethod', JSON.stringify(this.currentPaymentMethod));
      window.localStorage.setItem('currentPackage', JSON.stringify(this.currentPackage));
      window.localStorage.setItem('paymentLang', this.currentLang);
      this.$store.commit('setCurrentPayment', this.currentPaymentMethod.id);
      $('#pay-order').modal('hide');
      $('#creating-order').modal('show');
    },

    createOrderByStripe(stripeToken, recaptchaToken) {
      this.$http
        .post('api/topup-order?version=v2', {
          package_id: this.currentPackage.id,
          payment_method_id: this.currentPaymentMethod.id,
          promotion_source: cookie.getCookie('promotion_source') || ''
        })
        .then(
          response => {
            if (response.body.code === 0) {
              this.topupOrder = response.body.data;
              this.stripePay(stripeToken, recaptchaToken);
            } else {
              this.disabled = false;
              this.handleStripeError();
              this.$toast(response.body.message);
            }
          },
          () => {
            this.disabled = false;
            this.handleStripeError();
          }
        );
    },

    stripePay(stripeToken, recaptchaToken) {
      this.$http
        .patch('api/topup-order/' + this.topupOrder.order_id + '/stripe/complete-purchase?web=1', {
          id: this.topupOrder.order_id,
          stripeToken: stripeToken,
          recaptcha_token: recaptchaToken
        })
        .then(
          response => {
            switch (response.body.code) {
              case 0: {
                // Event snippet for pay_credit_card page
                const eventValue = [
                  'pay_credit_card',
                  'pay_credit_card',
                  response.body.data.order_id,
                  response.body.data.order_detail.total_amount,
                  response.body.data.order_detail.currency_symbol,
                  response.body.data.order_detail.plan_name,
                  response.body.data.order_detail.plan_fee,
                  response.body.data.order_detail.device_count
                ];
                this.gtmEvent(...eventValue);
                $('#pay-order').modal('hide');
                this.$store.commit('setOrderNumber', this.topupOrder.order_id);
                this.$store.commit('setQueryPayStatus', true);
                if (response.body.data.state === 'paid') {
                  if (cookie.getCookie('promotion_source')) {
                    cookie.removeCookie('promotion_source');
                  }
                }
                break;
              }
              case 130: {
                this.disabled = false;
                this.handleStripeError();
                this.$toast(this.notFindOrder);
                break;
              }
              default: {
                this.disabled = false;
                this.handleStripeError();
                this.$toast(response.body.message);
                break;
              }
            }
          },
          () => {
            this.disabled = false;
            this.handleStripeError();
          }
        );
    },

    stripeSubscribe(stripeToken, recaptchaToken) {
      let postParam = {
        package_id: this.currentPackage.id,
        payment_method_id: this.currentPaymentMethod.id,
        promotion_source: cookie.getCookie('promotion_source') || ''
      };
      if (stripeToken) {
        postParam.token = stripeToken;
        postParam.recaptcha_token = recaptchaToken;
      }
      this.$http.post('api/topup-subscription/create?web=1', postParam).then(
        response => {
          switch (response.body.code) {
            case 0: {
              // Event snippet for subscribe_credit_card page
              const eventValue = [
                'subscribe_credit_card',
                'pay_credit_card',
                response.body.data.subscription_id,
                response.body.data.package_detail.subscribe_price.CNY,
                response.body.data.package_detail.currency_code,
                response.body.data.package_detail.name,
                response.body.data.package_detail.price,
                response.body.data.package_detail.device_count
              ];
              this.gtmEvent(...eventValue);
              $('#pay-order').modal('hide');
              this.$store.commit('setSubscriptionId', response.body.data.subscription_id);
              this.$store.commit('setQuerySubscriptionStatus', true);
              break;
            }
            case 130: {
              this.disabled = false;
              this.handleStripeError();
              this.$toast(this.notFindOrder);
              break;
            }
            case 141: {
              this.disabled = false;
              this.handleStripeError();
              let subscriptionInfo = {
                subscription_id: response.body.data.subscription_id,
                payment_method: response.body.data.payment_method_name,
                package_name: response.body.data.package_detail.name
              }
              this.$parent.$parent.setSubscriptionInfo(subscriptionInfo)
              break;
            }
            default: {
              this.disabled = false;
              this.handleStripeError();
              this.$toast(response.body.message);
              break;
            }
          }
        },
        () => {
          this.disabled = false;
          this.handleStripeError();
        }
      );
    },

    paypalPay() {
      addProduct(getGaData(this.currentPackage, this.subTotal));
      setAction('checkout', { step: 2, list: 'PlexVPN', option: this.currentPaymentMethod.id });
      window.localStorage.setItem('currentPaymentMethod', JSON.stringify(this.currentPaymentMethod));
      if (this.isSubscribe) {
        // Event snippet for pay_now_subscribe_paypal page
        const eventValue = [
          'pay_now_subscribe_paypal',
          'pay_now',
          this.topupOrder.order_id,
          this.topupOrder.order_detail.total_amount,
          this.topupOrder.order_detail.currency_symbol,
          this.currentPackage.name,
          this.currentPackage.price,
          this.currentPackage.device_count
        ];
        this.gtmEvent(...eventValue);
        window.localStorage.setItem('isSubscribe', true);
      } else {
        // Event snippet for pay_now_paypal page
        const eventValue = [
          'pay_now_paypal',
          'pay_now',
          this.topupOrder.order_id,
          this.topupOrder.order_detail.total_amount,
          this.topupOrder.order_detail.currency_symbol,
          this.currentPackage.name,
          this.currentPackage.price,
          this.currentPackage.device_count
        ];
        this.gtmEvent(...eventValue);
      }
      window.localStorage.setItem('currentPackage', JSON.stringify(this.currentPackage));
      window.localStorage.setItem('current-payment-method', this.currentPaymentMethod.id);
      window.localStorage.setItem('paymentLang', this.currentLang);
      this.$store.commit('setCurrentPayment', this.currentPaymentMethod.id);
      $('#pay-order').modal('hide');
      $('#creating-order').modal('show');
    },

    airwallex() {
      this.show.paymentMethods = false
      this.show.airwallexIframe = true
      this.show.loading = true
      let wap = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? 1 : 0
      this.$http.post(`api/topup?web=1&wap=${wap}&version=v2`, {
        payment_method_id: this.currentPaymentMethod.id,
        package_id: this.currentPackage.id,
        sub_channel: this.currentPaymentMethod.channel_id || '',
        promotion_source: cookie.getCookie('promotion_source') || ''
      }).then((response) => {
        if (response.body.code === 0) {
          if (this.currentPaymentMethod.channel_id) {
            $('head').append('<meta name="referrer" content="no-referrer"/>')
          }
          window.localStorage.setItem('orderNumber', response.body.data.order_id)
          window.localStorage.setItem('orderTracked', false)
          this.$store.commit('setOrderNumber', response.body.data.order_id);
          this.airwallexIframe_url = response.body.data.payment_extras.redirect_url

          var iframeEle = document.getElementById("iframe")
          let lang = window.localStorage.getItem("currentLang")
          let that = this
          if (iframeEle.attachEvent) {// IE
            iframeEle.attachEvent('onload', function () {
              that.show.loading = false
              iframeEle.contentWindow.postMessage({language: lang}, '*')
            })
          } else {// Other
            iframeEle.onload = function () {
              that.show.loading = false
              iframeEle.contentWindow.postMessage({language: lang}, '*')
            }
          }

          if (this.currentPaymentMethod.channel_id) {
            $('meta[name=referrer]').remove()
          }
        } else {
          this.errorMessage = response.body.message
          window.localStorage.setItem('errorMessage', response.body.message)
        }
      })
    },

    paymentwallPay() {
      addProduct(getGaData(this.currentPackage, this.subTotal));
      setAction('checkout', { step: 2, list: 'PlexVPN', option: this.currentPaymentMethod.id });
      window.localStorage.setItem('currentPaymentMethod', JSON.stringify(this.currentPaymentMethod));
      if (this.isSubscribe) {
        // Event snippet for pay_now_subscribe_paymentwall page
        const eventValue = [
          'pay_now_subscribe_paymentwall',
          'pay_now',
          this.topupOrder.order_id,
          this.topupOrder.order_detail.total_amount,
          this.topupOrder.order_detail.currency_symbol,
          this.currentPackage.name,
          this.currentPackage.price,
          this.currentPackage.device_count
        ];
        this.gtmEvent(...eventValue);
        window.localStorage.setItem('isSubscribe', true);
      } else {
        // Event snippet for pay_now_paymentwall page
        const eventValue = [
          'pay_now_paymentwall',
          'pay_now',
          this.topupOrder.order_id,
          this.topupOrder.order_detail.total_amount,
          this.topupOrder.order_detail.currency_symbol,
          this.currentPackage.name,
          this.currentPackage.price,
          this.currentPackage.device_count
        ];
        this.gtmEvent(...eventValue);
      }
      window.localStorage.setItem('currentPackage', JSON.stringify(this.currentPackage));
      window.localStorage.setItem('paymentLang', this.currentLang);
      this.$store.commit('setCurrentPayment', this.currentPaymentMethod.id);
      $('#pay-order').modal('hide');
      $('#creating-order').modal('show');
    },
    trackRecharge: function (action) {
      // The value (the last argument) must be an integer
      this.$ga.event('Recharge', action, this.currentPackage.name, parseInt(this.subTotal));
    },
    openValue(name) {
      if (name === 'month') {
        this.monthShow = !this.monthShow;
      } else {
        this.yearShow = !this.yearShow;
      }
    },
    getValue(name, n) {
      if (name === 'month') {
        this.month = n;
        this.monthShow = false;
      } else {
        this.year = new Date().getFullYear() + (n - 1);
        this.yearShow = false;
      }
    },
    handleStripeError() {
      this.show.loading = false;
      $('button.form-submit').show();
      $('.trier-subscribe-notice').css({ marginTop: '0.2rem' });
    },
    // Load the JavaScript API with your sitekey
    loadV3Stripe() {
      let scriptDOM = document.createElement('script');
      scriptDOM.src = 'https://www.recaptcha.net/recaptcha/api.js?render=6LfCFPwcAAAAAGAjhsmzkntOSkLeS0xvAalAM6n5';
      document.body.appendChild(scriptDOM);
    },
    validateGrecaptcha() {
      if (document.getElementsByClassName('grecaptcha-badge').length == 0) {
        this.loadV3Stripe();
        return false;
      }
      return true;
    },
    // Call grecaptcha.execute
    verification(e, stripeToken, callback) {
      e.preventDefault();
      grecaptcha.ready(function () {
        grecaptcha
          .execute('6LfCFPwcAAAAAGAjhsmzkntOSkLeS0xvAalAM6n5', { action: 'submit' })
          .then(function (recaptchaToken) {
            callback(stripeToken, recaptchaToken);
          })
          .catch(function () {
            callback(stripeToken);
          });
      });
    },
    getPaymentMethods() {
      this.$store
        .dispatch('getPaymentMethods')
        .then(response => {
          if (response.data.code === 0) {
            this.show.loading = false;
            this.loadPaymentMethodsFail = false;
            this.disabled = false;
          }
        })
        .catch(err => {
          this.loadPaymentMethodsFail = true;
          this.disabled = true;
          console.log(err);
        });
    },
    initPaymentStatus() {
      this.disabled = false;
      this.$store.commit('setCardNumberEmpty', true);
      if (this.show.paymentMethods) {
        this.cardName = '';
        this.$store.commit('setNameError1', false);
        this.$store.commit('setCardError', '');
        addProduct(getGaData(this.currentPackage, this.subTotal));
        setAction('checkout', { step: 1, list: 'PlexVPN' });
        this.$store.commit('setDefaultPaymentMethod');
        if (this.currentPaymentMethod.id === 'stripe') {
          this.show.stripePay = true;
        } else {
          this.show.stripePay = false;
        }
      }
    }
  },
  filters: {
    discountFee(order) {
      let discountFee = (
        parseFloat(order.order_detail.plan_fee) +
        parseFloat(order.order_detail.upgrade_fee) -
        parseFloat(order.order_detail.total_amount)
      ).toFixed(2);
      return discountFee > 0 ? discountFee : 0;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '../../assets/scss/variables';
@import '../../assets/scss/reset-modal';
@import '../../assets/scss/mixins/button';
@import 'payorder';
</style>




// WEBPACK FOOTER //
// IndexMain.vue?e7251bf6